import { render, staticRenderFns } from "./DashboardHandshakeIcon.vue?vue&type=template&id=72dae536&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72dae536",
  null
  
)

export default component.exports